/**
 * Keep cart page line items visible.
 * 1) Restore from SSR backup if WPD/theme wipes [data-line-items]
 * 2) If backup is empty/missing, rebuild rows from /cart.js with dual-DOM prices
 *    (visible data-vp-* + hidden data-cart-item-price) so WPD cannot blank amounts
 * Never location.reload() — that caused reload spam.
 */
(function () {
  if (window.__vpCartItemsGuard) return;
  window.__vpCartItemsGuard = true;
  window.__vpMayoristaCartGuard = true;

  var restoring = false;
  var rebuildPending = false;

  function linesEl() {
    return (
      document.querySelector('[data-section-type="cart"] [data-line-items]') ||
      document.getElementById('vp-cart-lines')
    );
  }

  function hasRows(el) {
    return !!(el && el.querySelector('.cart__items__row'));
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function money(cents) {
    var n = Number(cents);
    if (isNaN(n)) n = 0;
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(n, (window.theme && theme.moneyFormat) || '${{amount}}');
      }
    } catch (e) {}
    return '$' + (n / 100).toFixed(2);
  }

  function imgUrl(item) {
    if (!item || !item.image) return '';
    var u = String(item.image);
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u;
  }

  function buildRowsHtml(items) {
    if (!items || !items.length) return '';
    var html =
      '<div class="cart__items" id="vp-simple-cart-items" style="height:auto!important;overflow:visible!important;">';
    items.forEach(function (item, i) {
      var key = item.key || '';
      var vid = item.variant_id || '';
      var pid = item.product_id || '';
      var handle = item.handle || '';
      var qty = item.quantity || 1;
      var variantPrice = item.price != null ? item.price : item.final_price;
      var compare = item.compare_at_price || '';
      var unit = item.final_price != null ? item.final_price : item.price;
      var line = item.final_line_price != null ? item.final_line_price : unit * qty;
      var title = item.product_title || item.title || '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var img = imgUrl(item);
      var lineIndex = i + 1;
      var unitText = money(unit);
      var lineText = money(line);
      var wpd =
        ' data-wpd-cart-variant-id="' +
        esc(vid) +
        '" data-wpd-cart-item="' +
        esc(key) +
        '" data-wpd-cart-drawer-product-handle="' +
        esc(handle) +
        '" data-wpd-cart-drawer-variant-id="' +
        esc(vid) +
        '" data-wpd-cart-drawer-variant-price="' +
        esc(variantPrice) +
        '" data-wpd-cart-drawer-variant-compare-at-price="' +
        esc(compare) +
        '" data-wpd-cart-drawer-product-id="' +
        esc(pid) +
        '" data-wpd-cart-drawer-item="' +
        esc(key) +
        '" data-wpd-cart-drawer-quantity="' +
        esc(qty) +
        '"';

      html +=
        '<div class="cart__items__row" data-cart-item data-wpd-cart-item="' +
        esc(key) +
        '" data-vp-variant-id="' +
        esc(vid) +
        '" data-vp-key="' +
        esc(key) +
        '" style="display:block!important;padding:20px 0;border-bottom:1px solid rgba(0,0,0,.08);">' +
        '<div class="cart__items__grid" data-item style="display:grid!important;grid-template-columns:90px 1fr;gap:12px 16px;align-items:center;">' +
        '<div class="cart__items__image" style="width:90px;height:90px;">' +
        '<a href="' +
        esc(item.url || '#') +
        '">' +
        (img
          ? '<img class="cart__items__img" src="' +
            esc(img) +
            '" width="90" height="90" alt="' +
            esc(title) +
            '" loading="eager" style="display:block;width:90px;height:90px;object-fit:cover;">'
          : '<span style="display:block;width:90px;height:90px;background:#eee;"></span>') +
        '</a></div>' +
        '<div class="cart__items__title" style="color:#111;">' +
        '<p style="margin:0 0 6px;font-weight:600;"><a href="' +
        esc(item.url || '#') +
        '" style="color:inherit;text-decoration:none;">' +
        esc(title) +
        '</a></p>' +
        (variant ? '<p class="body-size-3" style="margin:0;opacity:.7;">' + esc(variant) + '</p>' : '') +
        '<p style="margin:10px 0 0;"><button type="button" class="vp-cart-remove-btn" data-remove-key="' +
        esc(key) +
        '">Remove</button></p></div>' +
        '<div class="cart__items__price" style="color:#111!important;font-size:15px!important;">' +
        '<span class="vp-unit-price" data-vp-unit-price data-vp-key="' +
        esc(key) +
        '" data-vp-variant-id="' +
        esc(vid) +
        '" data-cart-item-price' +
        wpd +
        ' style="color:#111!important;font-size:15px!important;">' +
        unitText +
        '</span></div>' +
        '<div class="cart__items__quantity">' +
        '<div class="quantity__wrapper" data-quantity-selector style="display:inline-flex;align-items:center;border:1px solid #ccc;">' +
        '<button class="quantity__button quantity__button--minus" data-decrease-quantity type="button" aria-label="Decrease quantity" style="width:36px;height:36px;border:0;background:transparent;font-size:18px;cursor:pointer;">&minus;</button>' +
        '<input data-quantity-input data-update-cart="' +
        esc(key) +
        '" class="quantity__input" type="number" min="0" id="updates_' +
        esc(key) +
        '" name="updates[]" value="' +
        esc(qty) +
        '" style="width:48px;padding:8px 4px;border:0;border-inline:1px solid #ccc;text-align:center;color:#111;">' +
        '<button class="quantity__button quantity__button--plus" data-increase-quantity type="button" aria-label="Increase quantity" style="width:36px;height:36px;border:0;background:transparent;font-size:18px;cursor:pointer;">+</button>' +
        '</div></div>' +
        '<div class="cart__items__total" style="color:#111!important;font-size:15px!important;font-weight:600;text-align:end;">' +
        '<span class="vp-line-price" data-vp-line-price data-vp-key="' +
        esc(key) +
        '" data-vp-variant-id="' +
        esc(vid) +
        '" data-wpd-cart-line-price data-wpd-cart-drawer-line-price' +
        wpd +
        ' style="color:#111!important;font-size:15px!important;">' +
        lineText +
        '</span></div>' +
        '</div></div>';
    });
    html += '</div>';
    return html;
  }

  function snapshotGood(el) {
    if (!el || !hasRows(el)) return;
    // Sync live input.value → attribute before snapshot (otherwise restore snaps 11 → 4)
    if (typeof window.__vpSnapshotCartLines === 'function') {
      window.__vpSnapshotCartLines();
      return;
    }
    el.querySelectorAll('[data-update-cart], [data-quantity-input]').forEach(function (input) {
      input.setAttribute('value', String(input.value));
    });
    if (el.innerHTML.indexOf('data-vp-unit-price') !== -1 || el.innerHTML.indexOf('cart__items__row') !== -1) {
      window.__vpCartLinesBackup = el.innerHTML;
    }
  }

  function restoreFromBackup(el) {
    // Prefer live cart.js — SSR/backup often has stale value="N" attributes
    return false;
  }

  function rebuildFromCartJs(el) {
    if (rebuildPending) return;
    rebuildPending = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        rebuildPending = false;
        if (!el || hasRows(el)) return;
        if (!cart || !cart.items || !cart.items.length) return;
        var html = buildRowsHtml(cart.items);
        if (!html || html.indexOf('cart__items__row') === -1) return;
        restoring = true;
        el.innerHTML = html;
        window.__vpCartLinesBackup = html;
        restoring = false;
        try {
          if (typeof window.wcpApplyLinePrices === 'function') window.wcpApplyLinePrices();
        } catch (e) {}
      })
      .catch(function () {
        rebuildPending = false;
      });
  }

  function restore() {
    var el = linesEl();
    if (!el || restoring) return;
    if (hasRows(el)) {
      snapshotGood(el);
      return;
    }
    if (restoreFromBackup(el)) return;
    rebuildFromCartJs(el);
  }

  function ensureFinalPriceNode() {
    var cartSection = document.querySelector('[data-section-type="cart"]');
    if (!cartSection || cartSection.querySelector('[data-cart-final]')) return;
    var btn = cartSection.querySelector('button[name="checkout"]');
    if (!btn) return;
    var span = document.createElement('span');
    span.setAttribute('data-cart-final');
    span.className = 'visually-hidden';
    span.setAttribute('aria-hidden', 'true');
    btn.appendChild(span);
  }

  function watch() {
    var el = linesEl();
    if (!el || !window.MutationObserver) return;
    var obs = new MutationObserver(function () {
      if (restoring) return;
      if (!hasRows(el)) restore();
    });
    obs.observe(el, { childList: true, subtree: true });
  }

  function init() {
    ensureFinalPriceNode();
    var el = linesEl();
    var tpl = document.getElementById('vp-cart-lines-ssr');
    if (tpl && tpl.innerHTML && tpl.innerHTML.indexOf('cart__items__row') !== -1) {
      window.__vpCartLinesBackup = tpl.innerHTML;
    } else if (el && hasRows(el)) {
      snapshotGood(el);
    }
    restore();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  setTimeout(restore, 400);
  setTimeout(restore, 1200);
  setTimeout(restore, 2500);
  setTimeout(restore, 5000);
})();
